import { IBreadcrumb } from '../../types/breadcrumb';
import { IApplicationState } from '../../types/redux';

export const selectBreadcrumbs = (state: IApplicationState): IBreadcrumb[] => {
  return state.breadcrumbs;
};
